<div class="bg-primary-dark full-height flex column center">
	<router-outlet></router-outlet>
</div>

